// extracted by mini-css-extract-plugin
module.exports = {"container":"rotated_arrow-module--container--2nJ_J"};